var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfileRound = function SvgIconProfileRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 287,
    height: 287,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 286,
    height: 286,
    rx: 143,
    stroke: "#fff"
  })));
};
export default SvgIconProfileRound;